/* Fransk katalog for locale-superplumma-workspace.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'route.superplumma': 'SuperPlumma',
  'nav.superplumma': 'SuperPlumma',
  'navhelp.superplumma': 'Travaillez avec SuperPlumma dans le chat et suivez la tâche dans l\'espace de travail.',
  'spw.eyebrow': 'Votre assistante comptable',
  'spw.intro': 'Que faisons-nous aujourd\'hui ? Demandez-moi de créer une facture, ou téléversez un justificatif. Le document s\'affiche ici pendant que nous y travaillons.',
  'spw.upload': 'Téléverser un justificatif',
  'spw.camera': 'Prendre une photo',
  'spw.dropHint': 'Vous pouvez aussi déposer un justificatif ici.',
  'spw.drop': 'Déposez le justificatif ici',
  'spw.uploading': 'Téléversement du justificatif …',
  'spw.uploadError': 'Impossible de téléverser le justificatif.',
  'spw.saveDraft': 'Enregistrer le brouillon',
  'spw.issued': 'La facture a été créée.',
  'spw.showProposal': 'Afficher la proposition',
  'spw.editDetails': 'Modifier les détails',
  'spw.addReceipt': 'Téléversez un justificatif dans le chat, ou prenez une photo.',
  'spw.proposal': 'Proposition d\'écriture',
  'spw.supplierMissing': 'Aucun fournisseur sélectionné',
  'spw.account': 'Compte',
  'spw.vat': 'TVA',
  'spw.notSelected': 'Non sélectionné',
  'spw.readingHint': 'La proposition s\'affiche une fois le justificatif lu ou les détails renseignés.',
  'spw.paymentAccount': 'Compte de paiement',
  'spw.unpaid': 'Non payé',
  'spw.approvalHint': 'Demandez à SuperPlumma de comptabiliser lorsque la proposition est prête. Vous pourrez contrôler et approuver l\'action.',
  'spw.openTask': 'Ouvrir la tâche',
  'spw.chat': 'Chat',
  'spw.workspace': 'Espace de travail',
  'spw.shared': 'Une seule comptabilité. Une vue complète.',
  'spw.receipts': 'Saisie des justificatifs',
  'spw.purchase': 'Achats',
  'spw.sale': 'Ventes',
  'spw.invoice': 'Brouillon de facture',
  'spw.choose': 'Choisir une tâche',
  'spw.loading': 'Ouverture de l\'espace de travail …',
  'spw.loadError': 'L\'espace de travail n\'a pas pu être chargé. Votre conversation est conservée.',
  'spw.retry': 'Réessayer',
  'spw.unavailable': 'Ouvrez SuperPlumma dans une entreprise active pour commencer.',
  'spw.changeTitle': 'Changer de tâche ?',
  'spw.changeText': 'Enregistrez les éventuelles modifications du formulaire avant de changer de tâche. Les modifications non enregistrées peuvent être perdues.',
  'spw.changeConfirm': 'Changer de tâche',
});
